import { TableWrapper } from './Styled';
import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';

export const JobManagerTable = () => {
  return (
    <TableWrapper>
      <TableHeader />
      <TableBody />
    </TableWrapper>
  );
};
